import React, { useState } from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import {
  CardContent,
  Grid,
  Card as MuiCard,
  LinearProgress,
} from "@mui/material";

import * as Enums from "src/utils/enums";
import useForm from "src/hooks/useForm";

import { getNextCode } from "src/services/generalService";
import { DefaultService } from "src/services/defaultService";

//import TestList from "./TestList";
import AMIndexList from "src/pages/components/AMIndexList";

const Card = styled(MuiCard)(spacing);

function Ledgers({ menuItemCode }) {
  const defaultService = new DefaultService("Ledgers");
  const [filterCriteria, setFilterCriteria] = useState({});

  //#region Api Calls
  const getNextCodeFunc = async () => {
    const { data } = await getNextCode(menuItemCode, "code", "");
    return data || "";
  };

  const getByIdFunc = async (id) => {
    const { data } = await defaultService.get(menuItemCode, id);
    //Remove id if rendered from server to keep id as it comes from url and not enter in infinite loop
    //also if not remoced copy form will not work
    if (data) {
      delete data.id;
      delete data.ID;
      delete data.Id;
      delete data.iD;
    }
    return data;
  };

  const saveFormFunction = async (menuItemCode, formData) => {
    const { data } = await defaultService.save(menuItemCode, formData);
    return data;
  };

  const deleteFunction = async (menuItemCode, formData) => {
    const { data } = await defaultService.delete(menuItemCode, formData);
    return data;
  };
  //#endRegion

  const {
    state: values,
    indexColumns,
    renderFormHeader,
    renderFormInput,
    preLoaded,
  } = useForm({
    menuItemCode: menuItemCode,
    nextCodeField: "code",
    getNextCodeFunc: getNextCodeFunc,
    getByIdFunc: getByIdFunc,
    saveFunction: saveFormFunction,
    deleteFunction: deleteFunction,
  });

  if (!preLoaded) return <LinearProgress my={2} />;

  const mainData = (
    <Card mb={6}>
      <CardContent>
        <Grid container spacing={4}>
          {renderFormInput("code", "text", {
            style: { maxWidth: 100 },
          })}
          {renderFormInput("arbName")}
          {renderFormInput("engName")}
          {renderFormInput("parentLedgerID", Enums.ControlType.AutoSearch)}
          {renderFormInput("ledgerTypeID", Enums.ControlType.AutoSearch)}
          {renderFormInput("ledgerNature", Enums.ControlType.AutoSearch)}
          {renderFormInput("notes")}
          {renderFormInput("subLedgerTypeID_A", Enums.ControlType.AutoSearch)}
          {renderFormInput("subLedgerTypeID_B", Enums.ControlType.AutoSearch)}
          {renderFormInput("subLedgerTypeID_C", Enums.ControlType.AutoSearch)}
          {renderFormInput("notActive", Enums.ControlType.CheckBox)}
        </Grid>
      </CardContent>
    </Card>
  );

  return (
    <React.Fragment>
      {renderFormHeader()}
      {!values.id && indexColumns && !!indexColumns.length && (
        <AMIndexList
          columns={indexColumns}
          // title={title}
          // filterControls={[
          //   {
          //     formId: null,
          //     reportId: "1",
          //     controlName: "OperationType",
          //     fieldName: "OperationType",
          //     caption: "Type",
          //     toolTip: "",
          //     dataType: "number",
          //     regExpression: "",
          //     maxLength: "99999",
          //     minLength: "1",
          //     maxValue: "",
          //     minValue: "",
          //     isHidden: false,
          //     defaultValue: "",
          //     required: true,
          //     disabled: false,
          //     section: 1,
          //     width: null,
          //     controlType: "autosearch",
          //     lookupId: 101,
          //     isAutoGenerate: 1,
          //     rank: 1,
          //     anotherCriteria: "",
          //   },
          //   {
          //     formId: null,
          //     reportId: "1",
          //     controlName: "FromDate",
          //     fieldName: "FromDate",
          //     caption: "From Date",
          //     toolTip: "",
          //     dataType: "date",
          //     regExpression: "",
          //     maxLength: "99999",
          //     minLength: "1",
          //     maxValue: "",
          //     minValue: "",
          //     isHidden: false,
          //     defaultValue: "",
          //     required: false,
          //     disabled: false,
          //     section: 1,
          //     width: null,
          //     controlType: "datepicker",
          //     lookupId: 0,
          //     isAutoGenerate: 1,
          //     rank: 2,
          //     anotherCriteria: "",
          //   },
          //   {
          //     formId: null,
          //     reportId: "1",
          //     controlName: "ToDate",
          //     fieldName: "ToDate",
          //     caption: "To Date",
          //     toolTip: "",
          //     dataType: "date",
          //     regExpression: "",
          //     maxLength: "99999",
          //     minLength: "1",
          //     maxValue: "",
          //     minValue: "",
          //     isHidden: false,
          //     defaultValue: "",
          //     required: false,
          //     disabled: false,
          //     section: 1,
          //     width: null,
          //     controlType: "datepicker",
          //     lookupId: 0,
          //     isAutoGenerate: 1,
          //     rank: 3,
          //     anotherCriteria: "",
          //   },
          // ]}
          // initialCriteria={filterCriteria}
          // onApplyFilter={(filterCriteria) => {
          //   setFilterCriteria({ ...filterCriteria });
          // }}
          getAll={defaultService.getAll}
        />
      )}
      {!!values.id && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            {mainData}
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
}

export default Ledgers;
